import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const summaryDashboardApi = createApi({
  baseQuery,
  reducerPath: 'summaryDashboardApi',
  endpoints: builder => ({
    getSummaryDashboardData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, application_section }) => ({
        url: `${formatString(
          endPoints.SummaryDashboard.select,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?${
          country !== null ? `country=${country}` : ''
        }&application=${application}&application_section=${application_section}&application_module_section=SUMMARY`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),

    getMilestoneDashboardData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, application_section }) => ({
        url: `${formatString(
          endPoints.SummaryDashboard.milestone,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?${
          country !== null ? `country=${country}` : ''
        }&application=${application}&application_section=${application_section}&application_module_section=SUMMARY`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),

    getStartupDashboardData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, application_section }) => ({
        url: `${formatString(
          endPoints.SummaryDashboard.startup,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?${
          country !== null ? `country=${country}` : ''
        }&application=${application}&application_section=${application_section}&application_module_section=SUMMARY`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),

    getEssentialDocsDashboardData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, application_section }) => ({
        url: `${formatString(
          endPoints.SummaryDashboard.essentialDocuments,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?${
          country !== null ? `country=${country}` : ''
        }&application=${application}&application_section=${application_section}&application_module_section=SUMMARY`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getQueriesDashboardData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, application_section }) => ({
        url: `${formatString(
          endPoints.SummaryDashboard.queries,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?${
          country !== null ? `country=${country}` : ''
        }&application=${application}&application_section=${application_section}&application_module_section=SUMMARY`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const {
  useLazyGetSummaryDashboardDataQuery,
  useLazyGetMilestoneDashboardDataQuery,
  useLazyGetStartupDashboardDataQuery,
  useLazyGetEssentialDocsDashboardDataQuery,
  useLazyGetQueriesDashboardDataQuery
} = summaryDashboardApi;
